import {
  Component,
  ElementRef,
  Injector,
  Input,
  OnInit,
  Renderer2,
  Type,
  resolveForwardRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { UpdateCurrentAccountId } from '@app/finxone-web-frontend/app/lib/actions/account.action';
import {
  GetBeneficiary,
  SetBeneficiaryLoadingStatus,
  SetSelectedBeneficiary,
} from '@app/finxone-web-frontend/app/lib/actions/beneficiary.action';
import { SetFormAction } from '@app/finxone-web-frontend/app/lib/actions/form-submission.action';
import { SetRole } from '@app/finxone-web-frontend/app/lib/actions/role.action';
import { Currency } from '@app/finxone-web-frontend/app/lib/dtos/currencies.dto';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import { FormSubmissionService } from '@app/finxone-web-frontend/app/lib/services/form-submission-service/form-submission-service.service';
import { WidgetsHideConditionsSelector } from '@app/finxone-web-frontend/app/lib/services/hide-conditions-service/hide-conditions-repository';
import { HideConditionsService } from '@app/finxone-web-frontend/app/lib/services/hide-conditions-service/hide-conditions.service';
import { AccountState, AccountStateModel } from '@app/finxone-web-frontend/app/lib/state/account.state';
import { ApiActions, ApiLoadingState } from '@app/finxone-web-frontend/app/lib/state/api-loading.state';
import {
  BeneficiaryState,
  BeneficiaryStateModel,
} from '@app/finxone-web-frontend/app/lib/state/beneficiary.state';
import { FormActionState } from '@app/finxone-web-frontend/app/lib/state/form-submision.state';
import { RoleState } from '@app/finxone-web-frontend/app/lib/state/role.state';
import { getComponentByLabel } from '@app/finxone-web-frontend/app/lib/utils/get-component.utils';
import { buildHandleBarModel } from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';
import {
  beneficiaryDetailsPayload,
  createRedirectionUrlFromNavigationOptions,
  removeDuplicateCurrencies,
  removeInvalidCurrencies,
} from '@app/finxone-web-frontend/app/lib/utils/utils';
import { BeneficiaryViewType, FormActionTypeEnum } from '@finxone-platform/form-action';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { beneficiarySelectionTemplate } from '@finxone-platform/shared/default-templates';
import { AlertHandlerService, IconCacheService } from '@finxone-platform/shared/services';
import {
  APP_ZONES,
  AccountInfoType,
  AppBuilderPreviewState,
  BaseCssProperties,
  BeneficiaryDataContext,
  NavigationOptionEnum,
  NavigationOptionsType,
  NewUiZoneWidgetConfig,
  PaymentFlowTypes,
  ProviderClass,
  SKELETON_LAYOUT_CONFIG_PATH,
  UiZoneWidgetAttributeConfig,
  ViewType,
  WidgetNames,
  baseCssConfigStyle,
  isMultiCurrencyAccountInfoType,
  isSavingsAccountInfoType,
  resolveSkeletonLoadingTemplate,
  resolveSkeletonRenderOptions,
} from '@finxone-platform/shared/sys-config-types';
import { Select, Store } from '@ngxs/store';
import Handlebars from 'handlebars';
import {
  Observable,
  Subject,
  debounceTime,
  distinctUntilChanged,
  map,
  merge,
  switchMap,
  take,
  takeUntil,
  tap,
} from 'rxjs';
import { GetBeneficiaryResponse } from '../../../../lib/services/account-service/account.type';
import { ConfigService } from '../../../../lib/services/config-service/config-service.service';
import { WidgetGridConfig } from '../../../../lib/utils/grid.types';
import { createChildWidgetInjector } from '../../../zones/utils';
import { FormSubmitter } from '../form-widgets/form-submitter/form-submitter.component';
import {
  beneficiaryListHandlers,
  beneficiaryScrollHandlers,
  createBeneficiarySearchConfig,
} from './beneficiary-selection-widget-shared';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-beneficiary-selection-widget',
  templateUrl: './beneficiary-selection-widget.component.html',
  styleUrls: ['./beneficiary-selection-widget.component.scss'],
})
export class BeneficiarySelectionWidgetComponent extends FormSubmitter implements OnInit {
  @AutoDestroy override destroy$: Subject<void> = new Subject<void>();
  beneficiaryData: GetBeneficiaryResponse[] = [];
  @Select(BeneficiaryState.getBeneficiary)
  beneficiaryData$!: Observable<BeneficiaryStateModel>;
  accountsData: AccountInfoType[] = [];
  @Select(AccountState.getAccounts)
  accountsData$!: Observable<AccountStateModel>;
  @Input() class: string | null;
  widgetGridConfig!: WidgetGridConfig;
  borderContentStyle: baseCssConfigStyle;
  pageNumber = 1;
  totalPages = 1;
  public carouselItemWidth = 93;
  currencies: Currency[];
  public widgetName = WidgetNames.BENEFICIARY_SELECTION_WIDGET;
  public viewType = ViewType.LIST;
  public layoutType = ViewType;
  public isApiInProgress = false;
  public appBuilderShowFetchingContent = false;
  public appBuilderShowNoRecordsContent = false;

  @Select(ApiLoadingState.getApiState(ApiActions.getBeneficiaries))
  private getBeneficiariesApiState$!: Observable<{ isLoading: boolean }>;
  private baseHandleBarModel: any;

  public enableSearch = true;
  public searchPlaceHolder: string;
  public searchIcon: string;
  public currentActiveStyle: baseCssConfigStyle;
  public currentInactiveStyle: baseCssConfigStyle;
  public currentSearchInputStyle: baseCssConfigStyle;
  public searchIconStyle: baseCssConfigStyle;
  public searchText: string;
  private searchTextChanged: Subject<string> = new Subject<string>();
  public baseStyle: baseCssConfigStyle;
  public beneficiariesCurrency: string;
  public loadingText?: string;
  public noRecordsText?: string;
  public templateFunction: HandlebarsTemplateDelegate<any>;
  public noRecordsTemplateFunction: HandlebarsTemplateDelegate<any>;
  public apiFetchingTemplateFunction: HandlebarsTemplateDelegate<any>;
  public orientation = 'vertical';
  private nextPageUrl: string;
  private navigationConfig: NavigationOptionsType | undefined;
  public beneficiaryListOptions: { label: string; value: string }[] = [];
  public selectedOption: { label: string; value: string };
  public dataContext = BeneficiaryDataContext.CURRENT_ACCOUNT_CONTEXT;
  public contextSwitch: boolean;

  private beneficiaryViewType = BeneficiaryViewType.ALL_LIST;

  public dropdownOptionItemTemplate: (ctx: string) => string = () => '';
  public dropdownInputCustomStyle: Record<string, unknown>;

  public footerWidgetInstances: Array<{
    component: Type<unknown>;
    injector: Injector;
  }> = [];

  constructor(
    protected override store: Store,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private configService: ConfigService,
    public dataIn: ProviderClass<UiZoneWidgetAttributeConfig>,
    private countriesCurrenciesService: CountriesCurrenciesService,
    private iconCacheService: IconCacheService,
    private router: Router,
    private formSubmissionService: FormSubmissionService,
    private alertHandlerService: AlertHandlerService,
    private hideConditionsService: HideConditionsService,
    private injector: Injector,
  ) {
    super(store);
    merge(
      this.configService.getCurrencies().pipe(
        map((response) => {
          const validCurrencies = removeInvalidCurrencies(response);
          this.currencies = removeDuplicateCurrencies(validCurrencies, 'currency_code');
        }),
      ),
      this.accountsData$.pipe(
        map((accounts) => {
          this.accountsData = accounts.accounts;
        }),
      ),
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.loadingText = this.dataIn.attri.widgetProperties?.['loadingText'];
    this.noRecordsText = this.dataIn.attri.widgetProperties?.['noRecordsText'];
    this.viewType = this.dataIn.attri.widgetProperties?.['viewType'] ?? this.viewType;
    this.beneficiaryViewType =
      this.dataIn.attri.widgetProperties?.['beneficiaryViewType'] ?? this.beneficiaryViewType;

    this.dataContext = this.dataIn.attri.widgetProperties?.['dataContext'] ?? this.dataContext;
    this.contextSwitch = this.dataIn.attri['contextSwitch'] ?? true;
    this.getBeneficiaryListData();
    this.getBeneficiariesApiState$.pipe(takeUntil(this.destroy$)).subscribe((result) => {
      this.isApiInProgress = result.isLoading;
      if (!result.isLoading) {
        this.getBeneficiaryData();
      }
    });

    this.initializeSearch();
  }

  ngOnInit() {
    if (this.dataIn != undefined && this.dataIn != null) {
      this.attri = this.dataIn.attri;
      this.setAppBuilderPreviewState();
      this.orientation = this.attri.widgetProperties?.['orientation'] ?? 'vertical';
      this.navigationConfig = this.attri?.['navigationOption']
        ? {
            navigationOption: this.attri?.['navigationOption'],
            zone: this.attri?.['zone'] ?? '',
            pageUrl: this.attri?.['pageUrl'] ?? '',
            pageTransition: this.attri?.['pageTransition'] ?? '',
            role: this.attri?.['role'] ?? '',
            tabRef: this.attri?.['tabRef'] ?? '',
            pageId: this.attri?.['pageId'] ?? '',
          }
        : undefined;
      this.carouselItemWidth = this.attri?.['carouselItemWidth'] ?? 93;
      if (this.attri?.widgetProperties?.['inputHeight']) {
        this.dropdownInputCustomStyle = { height: `${this.attri?.widgetProperties?.['inputHeight']}px` };
      }
      this.loadNestedWidgetConfig();
      this.setHandlebarsTemplate();
    }
    this.setHandlebarsTemplate();
    if (this.widgetGridConfig) {
      const hostElem = this.elementRef.nativeElement;
      this.renderer.setStyle(hostElem, 'grid-row', this.widgetGridConfig?.gridPosition.gridRow);
      this.renderer.setStyle(hostElem, 'grid-column', this.widgetGridConfig?.gridPosition.gridCol);
    }

    // a linked list row takes its box and text colour from the theme's List styling
    const rowStyleProperties =
      this.viewType === ViewType.LIST && this.attri?.widgetProperties?.['globalStyling']
        ? []
        : [
            BaseCssProperties.MARGIN,
            BaseCssProperties.PADDING,
            BaseCssProperties.BORDER,
            BaseCssProperties.BACKGROUND_COLOR,
            BaseCssProperties.BOX_SHADOW,
            BaseCssProperties.COLOR,
          ];
    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      ...rowStyleProperties,
      BaseCssProperties.V_ALIGN,
      BaseCssProperties.TEXTALIGN,
      BaseCssProperties.FONT_WEIGHT,
      BaseCssProperties.FONT_SIZE,
      BaseCssProperties.TEXT_FONT_STYLE,
    ]);
    this.baseStyle = this.configService.getSpecificBaseCssStyle(this.attri, []);
    this.searchInputConfig();
    this.subscribeToFormAction()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        if (response?.nextPageUrl) this.nextPageUrl = response.nextPageUrl;
      });
  }

  private loadNestedWidgetConfig() {
    this.footerWidgetInstances = Object.entries(this.dataIn.widgetConfig?.nestedWidgets ?? {})
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([_, widgetConfig]) => !!widgetConfig?.widgetProperties?.['isNestedWidget']) // filter to only include widgets that are marked as nested widgets
      .map(([widgetName, widgetConfig]) => {
        const component = resolveForwardRef(getComponentByLabel(widgetName as WidgetNames));

        const widget = {
          name: widgetName,
          attributes: widgetConfig,
        } as NewUiZoneWidgetConfig;

        const injector = createChildWidgetInjector(widget, this.injector, this.dataIn, []);

        return {
          widgetName,
          component,
          injector,
        };
      });
  }

  /**
   * Updates the beneficiary dropdown configuration and selected option.
   *
   * Steps:
   * 1. Build `beneficiaryListOptions` from the available beneficiary data.
   * 2. Try to match the currently selected beneficiary ID from the store with the list.
   * 3. If a match is found and not already selected, update `selectedOption` and trigger change.
   * 4. If no match exists, default to the first beneficiary in the list (if available).
   *
   */

  isPreselectDisabled = () => !!this.dataIn?.attri?.widgetProperties?.['isPreselectDisabled'];

  private setBeneficiaryListDropdownConfig() {
    // reset the beneficiary selection, when array is empty
    const EMPTY_OPTION = { label: '', value: '' };

    if (!this.beneficiaryData?.length) {
      this.selectedOption = EMPTY_OPTION;
      this.beneficiaryListOptions = [];
      this.updateFormActionState(''); // reset form action state
      return;
    }

    // Map beneficiary data to dropdown options
    this.beneficiaryListOptions =
      this.beneficiaryData?.map((beneficiary) => ({
        ...{ label: beneficiary.name, value: beneficiary.id, ...beneficiary },
      })) || [];

    if (this.isPreselectDisabled()) {
      return;
    }

    const formStateBeneficiary = this.store.selectSnapshot(FormActionState.getFormActionState)?.response
      ?.formData;

    const matchedBeneficiary = this.store.selectSnapshot(BeneficiaryState.getMatchedBeneficiaryById());

    // Case 1: Valid matched beneficiary and form state does not already have a matching ID
    if (
      matchedBeneficiary &&
      (!formStateBeneficiary?.['bid'] || this.selectedOption?.value !== matchedBeneficiary.id)
    ) {
      this.onUpdateSelectedDropdownOption(matchedBeneficiary);
      this.onBeneficiaryChange(matchedBeneficiary.id);
      return;
    }

    // Case 2: Form state has a valid beneficiary ID that matches the list
    if (
      formStateBeneficiary?.['bid'] &&
      this.beneficiaryData.some((beneficiary) => beneficiary.id === formStateBeneficiary['bid']) &&
      this.selectedOption?.value !== formStateBeneficiary['bid']
    ) {
      const validBeneficiary = this.beneficiaryData.find(
        (beneficiary) => beneficiary.id === formStateBeneficiary['bid'],
      );
      if (validBeneficiary) {
        this.onUpdateSelectedDropdownOption(validBeneficiary);
        this.onBeneficiaryChange(validBeneficiary.id);
      }
      return;
    }

    // Case 3: No valid match, fall back to the first beneficiary in the list
    if (!matchedBeneficiary && this.selectedOption?.value !== this.beneficiaryData[0]?.id) {
      const fallbackBeneficiary = this.beneficiaryData[0];
      if (fallbackBeneficiary) {
        this.onUpdateSelectedDropdownOption(fallbackBeneficiary);
        this.onBeneficiaryChange(fallbackBeneficiary.id);
      }
      return;
    }
  }

  public updateFormActionState(id: string) {
    this.formSubmissionService.submitIndividualForm(
      {
        selectedBeneficiaryId: id,
      },
      '',
      FormActionTypeEnum.BENEFICIARY_PAYMENT_CURRENCY_SELECTION,
    );
  }

  public onBeneficiaryChange(id: string, isEventChanged = false) {
    const selectedBeneficiaryDetails = this.beneficiaryData?.find((beneficiary) => beneficiary?.id === id);
    if (this.dataContext === BeneficiaryDataContext.BENEFICIARY_CURRENCY_CONTEXT) {
      this.updateFormActionState(id);
    } else {
      // all beneficiary context.
      // If current account currency does not match with selected beneficiary currency, update current account to match beneficiary currency to avoid any mismatch in the next steps of the flow
      this.updateSelectedAccountBasedOnBeneficiaryCurrency(selectedBeneficiaryDetails);

      this.store.dispatch(new SetSelectedBeneficiary(id));
      this.hideConditionsService.setHideConditionFromWidget(
        WidgetsHideConditionsSelector.SELECTED_BENEFICIARY,
      );
      if (selectedBeneficiaryDetails) {
        // TODO Update this to not use the base FormActionState
        this.store.dispatch(
          new SetFormAction({
            type: '',
            formData: beneficiaryDetailsPayload(selectedBeneficiaryDetails as GetBeneficiaryResponse),
            nextPageUrl: '',
          }),
        );
      }
    }
    // use isEventChanged to validate that it does not break the setBeneficiaryListDropdownConfig function changes
    if (selectedBeneficiaryDetails && isEventChanged) {
      this.onUpdateSelectedDropdownOption(selectedBeneficiaryDetails);
    }
  }

  public dropdownItemSelectedTemplate(): string {
    // selected dropdown item template
    if (this.attri?.widgetProperties?.['selectedDropdownItemTemplate'] && this.selectedOption?.label) {
      const selectedItemTemplate = Handlebars.compile(
        this.attri?.widgetProperties?.['selectedDropdownItemTemplate'] ?? '',
      );
      if (selectedItemTemplate) {
        return selectedItemTemplate(this.selectedOption);
      }
    }
    return '';
  }

  private setHandlebarsTemplate() {
    if (this.attri?.widgetProperties?.['dropdownItemTemplate']) {
      this.dropdownOptionItemTemplate = Handlebars.compile(
        this.attri?.widgetProperties?.['dropdownItemTemplate'] ?? '',
      );
    }

    const itemTemplate =
      this.orientation === 'horizontal'
        ? this.attri.widgetProperties?.['horizontalLayoutTemplate']
        : this.attri?.['itemConfig']?.itemTemplate;
    const noRecordsTemplate =
      this.orientation === 'horizontal'
        ? this.attri.widgetProperties?.['horizontalNoRecordsTemplate']
        : this.attri.widgetProperties?.['verticalNoRecordsTemplate'];
    const apiFetchingTemplate =
      this.orientation === 'horizontal'
        ? this.attri.widgetProperties?.['horizontalApiFetchingTemplate']
        : this.attri.widgetProperties?.['verticalApiFetchingTemplate'];
    this.templateFunction = Handlebars.compile(itemTemplate ?? '');
    this.noRecordsTemplateFunction = Handlebars.compile(noRecordsTemplate ?? '');
    this.apiFetchingTemplateFunction = Handlebars.compile(apiFetchingTemplate ?? '');
    buildHandleBarModel(this.store, '', this.countriesCurrenciesService, this.iconCacheService)
      .pipe(takeUntil(this.destroy$))
      .subscribe((model) => {
        this.baseHandleBarModel = model;
      });
  }

  private getBeneficiaryData() {
    this.beneficiaryData$
      .pipe(
        distinctUntilChanged((prev, curr) => {
          return (
            prev.items === curr.items &&
            prev.favoriteItems === curr.favoriteItems &&
            prev.recentPaidItems === curr.recentPaidItems &&
            prev.totalPages === curr.totalPages
          );
        }),
        take(1),
        map(({ items, favoriteItems, recentPaidItems, totalPages }) => {
          this.beneficiaryData = [];
          // reset selected beneficiary
          this.store.dispatch(new SetSelectedBeneficiary(''));
          switch (this.beneficiaryViewType) {
            case BeneficiaryViewType.ALL_LIST:
              this.beneficiaryData = items;
              break;

            case BeneficiaryViewType.FAVORITE_LIST:
              this.beneficiaryData = favoriteItems;
              break;

            case BeneficiaryViewType.RECENTLY_PAID_LIST:
              this.beneficiaryData = recentPaidItems;
              break;

            default:
              this.beneficiaryData = items;
              break;
          }
          this.totalPages = totalPages;
          this.setBeneficiaryListDropdownConfig();
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  private searchInputConfig() {
    this.enableSearch = this.dataIn.attri?.widgetProperties?.inputFieldSettings?.isAllowed ?? true;
    this.searchPlaceHolder = this.dataIn.attri?.widgetProperties?.inputFieldSettings?.label ?? 'Search';
    this.searchIcon = this.dataIn.attri?.widgetProperties?.icon ?? 'search';

    const { iconStyle, baseStyle, activeStyle, inactiveStyle } = this.configService.getInputFieldCssStyles(
      this.attri.widgetProperties,
    );

    this.currentInactiveStyle = {
      ...inactiveStyle,
      ...activeStyle,
    };
    this.currentActiveStyle = {
      ...activeStyle,
      ...baseStyle,
    };
    this.searchIconStyle = iconStyle;
    this.currentSearchInputStyle = this.currentInactiveStyle;
  }

  public searchValue(event: any) {
    this.searchText = event.target.value;
    this.searchTextChanged.next(this.searchText);
    this.getBeneficiaryData();
  }

  private initializeSearch() {
    const configMap = createBeneficiarySearchConfig({
      store: this.store,
      viewType: this.viewType,
      pageSize: this.pageSize,
      beneficiaryViewType: this.beneficiaryViewType,
      destroy$: this.destroy$,
    });

    const config = configMap[this.dataContext] ?? configMap['DEFAULT'];

    this.searchTextChanged
      .pipe(
        debounceTime(300),
        tap((searchText) => {
          this.searchText = searchText;
          this.pageNumber = 1;
        }),
        switchMap((searchText) => config.currency$().pipe(map((currency) => ({ searchText, currency })))),
        tap(({ searchText, currency }) => {
          this.store.dispatch(
            new GetBeneficiary(
              this.pageNumber,
              config.resolvePageSize(),
              searchText,
              undefined,
              config.resolveCurrency(currency || this.beneficiariesCurrency),
              this.viewType,
              this.beneficiaryViewType,
              this.dataContext,
            ),
          );
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  public updateStyles(event: boolean) {
    this.currentSearchInputStyle = event ? this.currentActiveStyle : this.currentInactiveStyle;
  }

  public getBeneficiaryListData(): void {
    beneficiaryListHandlers[this.dataContext]?.({
      store: this.store,
      destroy$: this.destroy$,

      dataContext: this.dataContext,
      viewType: this.viewType,
      beneficiaryViewType: this.beneficiaryViewType,

      pageNumber: this.pageNumber,
      pageSize: this.pageSize,

      setCurrency: (currency: string) => {
        this.beneficiariesCurrency = currency;
      },
    });
  }

  handleChildScroll(): void {
    if (!this.pagingEnabled || this.pageNumber === this.totalPages) {
      return;
    }

    this.store.dispatch(new SetBeneficiaryLoadingStatus(true));

    const nextPage = this.pageNumber + 1;
    this.pageNumber = nextPage;

    beneficiaryScrollHandlers[this.dataContext]?.({
      store: this.store,
      destroy$: this.destroy$,

      dataContext: this.dataContext,
      viewType: this.viewType,
      beneficiaryViewType: this.beneficiaryViewType,

      pageNumber: nextPage,
      pageSize: this.pageSize,
      searchText: this.searchText,

      beneficiariesCurrency: this.beneficiariesCurrency,

      setPageNumber: (page: number) => (this.pageNumber = page),
      setCurrency: (currency: string) => (this.beneficiariesCurrency = currency),
    });
  }

  public get pageSize(): number {
    if (this.dataIn.attri['pageSize'] != null) return this.dataIn.attri['pageSize'];
    else return 10;
  }

  public get pagingEnabled(): boolean {
    if (this.dataIn.attri['pagingEnabled'] != null) return this.dataIn.attri['pagingEnabled'];
    else return true;
  }

  public get beneficiarySelectionTemplate(): string {
    if (this.dataIn.attri?.['itemConfig']?.['itemTemplate'] != null)
      return this.dataIn.attri['itemConfig']['itemTemplate'];
    else return beneficiarySelectionTemplate;
  }

  public selectBeneficiary(beneficiaryDetails: GetBeneficiaryResponse) {
    if (this.dataContext === BeneficiaryDataContext.CURRENT_ACCOUNT_CONTEXT) {
      this.store.dispatch(new SetSelectedBeneficiary(beneficiaryDetails.id));
      this.formSubmissionService.resetCurrentPageFormGroups();
      let urlToRedirect = this.nextPageUrl;
      if (this.navigationConfig) {
        // TODO Update this to not use the base FormActionState
        this.store.dispatch(
          new SetFormAction({
            type: '',
            formData: beneficiaryDetailsPayload(beneficiaryDetails),
            nextPageUrl: '',
          }),
        );
        if (this.navigationConfig.navigationOption !== NavigationOptionEnum.USE_AS_BLANK) {
          urlToRedirect = createRedirectionUrlFromNavigationOptions(this.navigationConfig);
          const roleState = this.store.selectSnapshot(RoleState.getRole);
          if (this.navigationConfig.role !== roleState.role) {
            this.store.dispatch(new SetRole(this.navigationConfig.role));
          }
          this.router.navigateByUrl(urlToRedirect);
        }
        return;
      } else {
        // its the old way of doing the redirection based on some certain conditions,
        // needs to be removed in the future when navigationConfig is completely implemented
        this.updateFormStateAndRedirect(beneficiaryDetails, urlToRedirect);
      }
      this.hideConditionsService.setHideConditionFromWidget(
        WidgetsHideConditionsSelector.SELECTED_BENEFICIARY,
      );
    } else {
      this.onBeneficiaryChange(beneficiaryDetails.id);
      this.handleRedirection(beneficiaryDetails);
    }
  }

  private handleRedirection(beneficiaryDetails: GetBeneficiaryResponse): void {
    let urlToRedirect = this.nextPageUrl;
    if (this.navigationConfig) {
      if (this.navigationConfig.navigationOption !== NavigationOptionEnum.USE_AS_BLANK) {
        urlToRedirect = createRedirectionUrlFromNavigationOptions(this.navigationConfig);
        const roleState = this.store.selectSnapshot(RoleState.getRole);
        if (this.navigationConfig.role !== roleState.role) {
          this.store.dispatch(new SetRole(this.navigationConfig.role));
        }
        this.router.navigateByUrl(urlToRedirect);
      }
      return;
    } else {
      // its the old way of doing the redirection based on some certain conditions,
      // needs to be removed in the future when navigationConfig is completely implemented
      this.updateFormStateAndRedirect(beneficiaryDetails, urlToRedirect);
    }
  }

  private updateFormStateAndRedirect(beneficiaryDetails: GetBeneficiaryResponse, urlToRedirect: string) {
    this.formSubmissionService
      .submitIndividualForm(beneficiaryDetailsPayload(beneficiaryDetails), urlToRedirect)
      .then(() => {
        if (this.attri.widgetProperties?.widgetContext?.pageType === PaymentFlowTypes.SWIFT) {
          // A domestic GB beneficary has been selected which is not valid
          // for international payment flow
          if (!beneficiaryDetails?.address) {
            this.alertHandlerService.showAlertFn(
              'error',
              'Domestic beneficiary selected in international payments',
              'Payment Initiation Issue',
            );
          } else {
            this.checkUserAccountsAndRedirect(beneficiaryDetails);
          }
        } else if (this.attri.widgetProperties?.widgetContext?.pageType === PaymentFlowTypes.ALL_PAYMENTS) {
          if (
            beneficiaryDetails.destinationIdentifier.currency === 'GBP' ||
            beneficiaryDetails.destinationIdentifier.currency === 'EUR'
          ) {
            const url = this.configService.reRouteIfModal(APP_ZONES.BENEFICIARY_ZONE, 'view-beneficiary');
            this.router.navigateByUrl(url);
          } else {
            const redirectUrl = this.configService.reRouteIfModal(
              APP_ZONES.BENEFICIARY_ZONE,
              'view-beneficiary-intl',
            );
            this.router.navigateByUrl(redirectUrl);
          }
        } else {
          this.handleDomesticPayment(beneficiaryDetails);
        }
      });
  }

  public handleActiveIndexUpdate(event: number) {
    const isLastIndex = this.beneficiaryData.length - 1 === event;
    if (isLastIndex) {
      this.handleChildScroll();
    }
  }

  public renderNoRecordsTemplate() {
    return this.noRecordsTemplateFunction({
      ...this.baseHandleBarModel,
    });
  }

  /**
   * Preview states belong to the app builder canvas only, so a project published while one was
   * selected still loads its real loading and empty states for a customer. Both flags are assigned
   * rather than only set, so switching the preview back to Default clears them.
   */
  private setAppBuilderPreviewState(): void {
    if (!this.configService.getActiveConfigType().isWorkflow) {
      return;
    }
    const appBuilderState = this.attri.widgetProperties?.['appBuilderState'];
    this.appBuilderShowFetchingContent = appBuilderState === AppBuilderPreviewState.FETCHING;
    this.appBuilderShowNoRecordsContent = appBuilderState === AppBuilderPreviewState.NO_RECORDS;
  }

  /**
   * The canvas loads real beneficiaries from the mock services, so a previewed state would render
   * on top of them. These two stand in for an in-flight first page with nothing to show yet, which
   * is what makes the table draw its skeleton rows.
   */
  public get listingApiInProgress(): boolean {
    return this.isApiInProgress || this.appBuilderShowFetchingContent;
  }

  public get listingBeneficiaryData(): GetBeneficiaryResponse[] {
    return this.appBuilderShowFetchingContent || this.appBuilderShowNoRecordsContent
      ? []
      : this.beneficiaryData;
  }

  public renderApiFetchingTemplate() {
    // The designed skeleton wins over the widget's own fetching template, so the live app and the
    // skeleton designer render the same loading state from one config. In table view the table
    // draws the skeleton as real rows and cells, so the fetching template stays as it is.
    return resolveSkeletonLoadingTemplate(
      this.attri?.[SKELETON_LAYOUT_CONFIG_PATH],
      this.apiFetchingTemplateFunction({
        ...this.baseHandleBarModel,
      }),
      this.viewType,
      resolveSkeletonRenderOptions(this.attri),
    );
  }

  private checkUserAccountsAndRedirect(beneficiary: GetBeneficiaryResponse) {
    const currencyAccountExists = this.isCurrencyAccountExists(beneficiary);
    if (currencyAccountExists) {
      const currencyAccount = this.findCurrencyAccount(beneficiary);
      this.setCurrencyAccountAsSelectedAccount(currencyAccount?.accountId ?? '');
      const url = this.configService.reRouteIfModal(APP_ZONES.PAYMENT, 'intl-pay-beneficiary');
      this.router.navigateByUrl(url);
    } else {
      const redirectUrl = this.configService.reRouteIfModal(
        APP_ZONES.PAYMENT,
        'intl-no-source-currency-account',
      );
      this.router.navigateByUrl(redirectUrl);
    }
  }

  private handleDomesticPayment(beneficiary: GetBeneficiaryResponse) {
    const isSelectedAccountMatches = this.isSelectedAccountMatchesBeneficiaryCurrency(beneficiary);
    if (!isSelectedAccountMatches) {
      const currencyAccountExisting = this.isCurrencyAccountExists(beneficiary);
      if (currencyAccountExisting) {
        const currencyAccount = this.findCurrencyAccount(beneficiary);
        this.setCurrencyAccountAsSelectedAccount(currencyAccount?.accountId ?? '');
        this.redirectToInitiatePaymentPage();
      } else {
        this.alertHandlerService.showAlertFn(
          'error',
          'No domestic account found, please contact an administrator',
          'Payment Initiation Issue',
        );
      }
    } else {
      this.redirectToInitiatePaymentPage();
    }
  }

  private findCurrencyAccount(beneficiary: GetBeneficiaryResponse): AccountInfoType | undefined {
    const activeAccount = this.accountsData.find(
      (v) => v.currency === beneficiary.destinationIdentifier.currency,
    );
    return activeAccount;
  }

  private setCurrencyAccountAsSelectedAccount(accountId: string) {
    this.store.dispatch(new UpdateCurrentAccountId(accountId));
  }

  private redirectToInitiatePaymentPage() {
    const url = this.configService.reRouteIfModal(APP_ZONES.PAYMENT, 'initiate-a-payment');
    this.router.navigateByUrl(url);
  }
  private isCurrencyAccountExists(beneficiary: GetBeneficiaryResponse): boolean {
    let isExisting = false;
    const activeAccount = this.accountsData.find(
      (v) => v.currency === beneficiary.destinationIdentifier.currency,
    );
    isExisting = !!activeAccount;
    return isExisting;
  }

  private isSelectedAccountMatchesBeneficiaryCurrency(beneficiary: GetBeneficiaryResponse): boolean {
    const selectedAccountId = this.store.selectSnapshot(AccountState.getCurrentAccountId);
    const selectedAccount = this.accountsData.find((v) => v.accountId === selectedAccountId);
    const isSelectedAccountCurrencyMatchingWithBeneficiary = !!(
      selectedAccount?.currency === beneficiary.destinationIdentifier.currency
    );
    if (selectedAccount && isSelectedAccountCurrencyMatchingWithBeneficiary) {
      return true;
    } else {
      return false;
    }
  }

  private onUpdateSelectedDropdownOption(selectedBeneficiary: GetBeneficiaryResponse) {
    if (selectedBeneficiary) {
      this.selectedOption = {
        label: selectedBeneficiary.name,
        value: selectedBeneficiary.id,
        ...selectedBeneficiary,
      };
    }
  }

  updateSelectedAccountBasedOnBeneficiaryCurrency(
    selectedBeneficiaryDetails: GetBeneficiaryResponse | undefined,
  ) {
    const selectedAccount = this.store.selectSnapshot(AccountState.getCurrentAccount);
    if (
      selectedAccount &&
      !isSavingsAccountInfoType(selectedAccount) &&
      isMultiCurrencyAccountInfoType(selectedAccount)
    ) {
      if (
        !selectedAccount?.currency
          .map((c) => c.currency)
          .includes(selectedBeneficiaryDetails?.destinationIdentifier.currency ?? '')
      ) {
        console.warn(
          `Selected beneficiary currency ${selectedBeneficiaryDetails?.destinationIdentifier.currency} does not match with selected account currency ${selectedAccount?.currency}. Updating current account to match beneficiary currency.`,
        );
        const accounts = this.store.selectSnapshot(AccountState.getAccounts).accounts;

        const matchingCurrencyAccount = accounts
          .filter((a) => isMultiCurrencyAccountInfoType(a))
          .find((account) => {
            if (
              account.currency
                .map((c) => c.currency)
                .includes(selectedBeneficiaryDetails?.destinationIdentifier.currency ?? '')
            ) {
              return true;
            }
            return false;
          });

        if (matchingCurrencyAccount) {
          this.store.dispatch(new UpdateCurrentAccountId(matchingCurrencyAccount.accountId));
        }
      }
    } else {
      if (selectedBeneficiaryDetails?.destinationIdentifier.currency !== selectedAccount?.currency) {
        console.warn(
          `Selected beneficiary currency ${selectedBeneficiaryDetails?.destinationIdentifier.currency} does not match with selected account currency ${selectedAccount?.currency}. Updating current account to match beneficiary currency.`,
        );
        const accounts = this.store.selectSnapshot(AccountState.getAccounts).accounts;

        const matchingCurrencyAccount = accounts.find((account) => {
          if (account.currency === selectedBeneficiaryDetails?.destinationIdentifier.currency) {
            return true;
          }
          return false;
        });

        if (matchingCurrencyAccount) {
          this.store.dispatch(new UpdateCurrentAccountId(matchingCurrencyAccount.accountId));
        }
      }
    }
  }
}
